import { MockGoalsProps } from '../types/mockData'
import { mockGoals, mockGoalsGeneral } from '../utils/dashMockData'
import { APIDecoratorWithBaseURI } from './api'

export interface addDailyGoalParams {
  status: boolean
  msg: string
}

export interface DeleteGoalPayloadProps {
  data: DeleteGoalPayloadDataProps
}

export interface DeleteGoalPayloadDataProps {
  eventId: string
  datas: string[]
}

export interface UpdateGeneralGoalProp {
  data: UpdateGeneralGoalDataProp
}

export interface UpdateGeneralGoalDataProp {
  eventId: string
  goal: string
}
export interface AddDailyGoalsPayloadProps {
  eventId: string
  goal: string
  datas: string[]
}

const PA_PREFIX = 'producer/analytics/'

// GENERAL GOAL REQUESTS
//
export const updateGeneralGoalRequest = async (
  token: string,
  payload: UpdateGeneralGoalDataProp
): Promise<boolean> => {
  const url = `${PA_PREFIX}generalEventGoals`
  const data = await APIDecoratorWithBaseURI()
    .post<any>(url, payload as UpdateGeneralGoalDataProp)
    .then((r: any) => {
      if (r.status === 200) return true
      if (r.status !== 200) return false
      return true
    })
    .catch((e) => {
      return false
    })
  return data
}

export const getGeneralEventGoal = async (
  token: string,
  id: string,
  endDate: string,
  startDate: string
): Promise<any> => {
  const url = `${PA_PREFIX}generalEventGoals?eventId=${
    id as string
  }&startDate=${endDate}&endDate=${startDate}`
  const data = await APIDecoratorWithBaseURI()
    .get<any>(url)
    .then((r: any) => {
      if (r.data.body === undefined) {
        mockGoalsGeneral.isLoading = false
        mockGoalsGeneral.isError = false
        mockGoalsGeneral.isMessage = true
        return mockGoalsGeneral
      } else {
        return r.data.body
      }
    })
    .catch((e) => {
      mockGoalsGeneral.isLoading = false
      mockGoalsGeneral.isError = true
      mockGoalsGeneral.isMessage = false
      return mockGoalsGeneral
    })
  return data
}

// DAILY GOALS REQUESTS
//
export const addDailyGoalsRequest = async (
  token: any,
  payload: AddDailyGoalsPayloadProps
): Promise<addDailyGoalParams> => {
  const url = `${PA_PREFIX}eventGoals`

  const data = await APIDecoratorWithBaseURI()
    .post<any>(url, payload)
    .then((response) => {
      return {
        status: response.data.success,
        msg: '',
      }
    })
    .catch((err) => {
      return {
        status: false,
        msg: err?.response?.data?.message,
      }
    })
  return data
}

export const deleteDailyGoalRequest = async (
  token: string,
  payload: DeleteGoalPayloadProps
): Promise<any> => {
  const url = `${PA_PREFIX}eventGoals`
  const data = await APIDecoratorWithBaseURI()
    .delete(url, payload as DeleteGoalPayloadProps)
    .then((r: any) => {
      if (r.status === 200) return true
      if (r.status !== 200) return false
      return true
    })
    .catch((e) => {
      return false
    })
  return data
}

export const getDailyEventGoals = async (
  token: string,
  id: string | number,
  endDate: string,
  startDate: string
): Promise<MockGoalsProps> => {
  const url = `${PA_PREFIX}eventGoals?eventId=${
    id as string
  }&startDate=${endDate}&endDate=${startDate}`
  const data = await APIDecoratorWithBaseURI()
    .get<any>(url)
    .then((r: any) => {
      if (r.data.body === undefined) {
        mockGoals.isLoading = false
        mockGoals.isError = false
        mockGoals.isMessage = true
        return mockGoals
      } else {
        return r.data.body
      }
    })
    .catch((e) => {
      mockGoals.isLoading = false
      mockGoals.isError = true
      mockGoals.isMessage = false
      return mockGoals
    })
  return data
}
